<template>
  <div>
    <div class="row">
      <div v-if="online" class="col-md-12">
        <loading v-if="! showContent"></loading>
        <div class="blogs bloco" v-if="showContent">
          <h2 class="titulo">{{ title }}</h2>

          <!--lista não encontrada-->
          <!--<div class="lista-nao-encontrada">-->
          <!--<i class="fas fa-music"></i>-->
          <!--<span>Lista não encontrada</span>-->
          <!--<p>Ouve um erro ao buscar a lista. Por favor aguarde alguns segundos e tente novamente.</p>-->
          <!--</div>-->


          <ul class="proximas_ultimas_musicas">
            <li v-if="mount == 'live'">
              <i class="fa fa-microphone" aria-hidden="true"></i>
              <strong>AO VIVO </strong><br>
              <small>{{ siteTitleName }}</small>
            </li>
            <li v-for="item in items" v-if="mount == 'autodj'">
              <span><img :src="item.cover"></span>
              <img v-if="item.cover" :src="item.cover">
              <strong>{{ item.tags.name }}</strong><br>
              <small>{{ item.tags.title }}</small>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
<script type="text/javascript">
  import {get} from '../../helpers/api';
  import Loading from '../common/Loading.vue';

  export default {
    components: {
      Loading
    },
    props: ['bloco'],

    data() {
      return {
        title: 'Músicas',
        showContent: false,
        items: [],
        mount: this.$store.getters['getCurrentInfo'].mount,
        online: this.$store.getters['getCurrentInfo'].online,
        siteTitleName: ''
      }
    },
    created() {
      let self = this;
      self.items = [];
      if (this.bloco.nome) {
        this.title = this.bloco.nome;
      }
      get('content/' + self.bloco.id).then(function (response) {
        self.showContent = true;
        self.mount = response.data.result.data.mount;
        self.items = [];
        if (response.data.result.data.data) {
          response.data.result.data.data.forEach(function (value, key) {
            self.items.push(value)
          });
        }
      });
      self.showContent = true;
    },
    mounted() {
      let self = this;

      setInterval(function () {
        self.getInfo();
      }, 10000);
    },
    methods: {
      getInfo() {
        let self = this;
        get('content/' + self.bloco.id).then(function (response) {
          self.showContent = true;
          self.mount = response.data.result.data.mount;
          self.items = [];
          if (response.data.result.data.data) {
            response.data.result.data.data.forEach(function (value, key) {
              self.items.push(value)
            });
          }

        });
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/home/Musics.vue